import React from 'react';
import PropTypes from 'prop-types';

import {Box} from 'views/components';

import {Calendar as RBCalendar, Views, momentLocalizer} from 'react-big-calendar';

import momentTimezone from 'moment-timezone';

import withDragAndDrop from 'react-big-calendar/lib/addons/dragAndDrop';
import 'react-big-calendar/lib/sass/styles.scss';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.scss';

const DragAndDropCalendar = withDragAndDrop(RBCalendar);

const Calendar = (props) => {
  // Set default timezone if none is provided
  const timezone = props.timezone || momentTimezone.tz.guess();
  momentTimezone.tz.setDefault(timezone);
  const localizer = momentLocalizer(momentTimezone);

  // Default handlers for drag and drop/resize if not provided in props
  const onEventDrop = (eventDropInfo) => {
    if (props.onEventDrop) {
      props.onEventDrop(eventDropInfo);
    }
  };

  const onEventResize = (eventResizeInfo) => {
    if (props.onEventResize) {
      props.onEventResize(eventResizeInfo);
    }
  };

  React.useEffect(() => {
    return () => {
      momentTimezone.tz.setDefault();
    };
  }, []);
  return (
    <Box
      sx={{
        '& .rbc-background-event': {
          zIndex: 2,
          padding: '0px !important',
          border: 'none !important',
          backgroundColor: 'transparent !important',
        },
        '& .rbc-event-label': {
          display: 'none !important',
        },
        '& .rbc-events-container': {
          width: '100% !important',
          padding: '0px !important',
        },
        '& .rbc-event': {
          border: 'none !important',
          outline: 'none !important',
          boxShadow: 'none !important',
          backgroundColor: 'transparent !important',
          padding: '0px !important',
          margin: '0px !important',
          width: '100% !important',
        },
        '& .rbc-month-view .rbc-event': {
          backgroundColor: 'transparent !important',
          width: '100% !important',
        },
        '& .rbc-addons-dnd .rbc-addons-dnd-row-body': {
          position: 'relative',
        },
        '& .rbc-addons-dnd .rbc-addons-dnd-drag-row': {
          outline: 'none !important',
        },
        '& .rbc-addons-dnd .rbc-event': {
          backgroundColor: 'transparent !important',
          width: '100% !important',
        },
        '& .rbc-addons-dnd .rbc-event-content': {
          backgroundColor: 'transparent !important',
          width: '100% !important',
        },
        '& .rbc-month-view .rbc-month-row': {
          minHeight: '210px !important',
          // Uncomment to enable vertical scrolling in month view
          // overflowY: 'visible',
        },
      }}
    >
      {props.draggableEvents ? (
        <DragAndDropCalendar
          key={timezone}
          localizer={localizer}
          onEventDrop={onEventDrop}
          onEventResize={onEventResize}
          resizable
          selectable={false}
          {...props}
        /> ) : (
        <RBCalendar
          key={timezone}
          localizer={localizer}
          {...props}
        />
      )}
    </Box>
  );
};
Calendar.propTypes = {
  timezone: PropTypes.string,
  onEventDrop: PropTypes.func,
  onEventResize: PropTypes.func,
  draggableEvents: PropTypes.bool,
};
const MemoReact = React.memo(Calendar);

export {
  MemoReact as Calendar,
  Views,
};
